/**
 * StopButton
 *
 * Permanent hand-icon button for stopping suspicious interactions.
 */

import styles from './stop-button.module.css';

interface StopButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

function HandIcon(): JSX.Element {
  return (
    <svg
      className={styles.icon}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
    >
      <path d="M9 11V5.5C9 4.67 9.67 4 10.5 4S12 4.67 12 5.5V10h1V6.5C13 5.67 13.67 5 14.5 5S16 5.67 16 6.5V10h1V7.5C17 6.67 17.67 6 18.5 6S20 6.67 20 7.5V12c0 2.76-2.24 5-5 5H9.5c-2.21 0-4-1.79-4-4v-2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11H9z" />
    </svg>
  );
}

export function StopButton({ onClick, disabled = false }: StopButtonProps): JSX.Element {
  return (
    <button
      type="button"
      className={`${styles.stopButton} cn-zoom-ui`}
      onClick={onClick}
      disabled={disabled}
      aria-label="Stopper l'interaction"
      title="Stopper l'interaction"
    >
      <HandIcon />
      <span className={styles.label}>STOP</span>
    </button>
  );
}
